module.exports = {"411627100":"城关回族镇","411627101":"常营镇","411627102":"逊母口镇","411627103":"老冢镇","411627104":"朱口镇","411627105":"马头镇","411627106":"龙曲镇","411627107":"板桥镇","411627108":"符草楼镇","411627109":"马厂镇","411627110":"毛庄镇","411627111":"张集镇","411627112":"清集镇","411627113":"大许寨镇","411627114":"转楼镇","411627200":"城郊乡","411627201":"杨庙乡","411627202":"王集乡","411627203":"高贤乡","411627204":"芝麻洼乡","411627206":"独塘乡","411627208":"五里口乡","411627210":"高朗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411627.json
// module id = 1682
// module chunks = 0